<template>
  <div>
    <px-view-header v-if="!isModalView"
                    title="Aprovação" title-class="font-weight-bold"
                    :breadcrumbs="breadcrumbs">
      <template v-slot:before>
        <v-btn class="mb-4 mr-1" icon x-large color="primary" link to="/aprovacoes">
          <v-icon>
            mdi-arrow-left
          </v-icon>
        </v-btn>
      </template>
    </px-view-header>
    <div v-if="loading">
      <px-circular-loading/>
    </div>
    <div v-if="!loading && aprovacao">
      <aprovacao-detalhes-dados-basicos :aprovacao="aprovacao"/>
      <aprovacao-detalhes-tabs :aprovacao="aprovacao"/>
      <aprovacao-detalhes-aprovadores class="mt-3" :aprovacao="aprovacao" @update="onUpdate"/>
      <aprovacao-detalhes-produtos :aprovacao="aprovacao"/>
      <aprovacao-detalhes-mensagens-personalizadas
        v-if="checkMessages"
        :aprovacao="aprovacao"/>
    </div>
  </div>
</template>

<script>
import AprovacaoService from '@/modules/aprovacao/aprovacao-service';
import AprovacaoDetalhesDadosBasicos from './AprovacaoDetalhesDadosBasicos.vue';
import AprovacaoDetalhesAprovadores from './AprovacaoDetalhesAprovadores.vue';
import AprovacaoDetalhesProdutos from './AprovacaoDetalhesProdutos.vue';
import AprovacaoDetalhesTabs from './tabs/AprovacaoDetalhesTabs.vue';
import AprovacaoDetalhesMensagensPersonalizadas from './AprovacaoDetalhesMensagensPersonalizadas.vue';

export default {
  props: {
    isModalView: {
      type: Boolean,
      default: false,
    },
    aprovacaoIdProp: {
      type: [String, Number],
    },
  },
  data() {
    return {
      id: null,
      aprovacao: null,
      loading: false,
      breadcrumbs: [
        { text: 'Gestão de compras' },
        { text: 'Aprovações', to: '/aprovacoes' },
        { text: 'Detalhes' },
      ],
    };
  },
  computed: {
    checkMessages() {
      return this.aprovacao.mensagensPersonalizadas
        && this.aprovacao.mensagensPersonalizadas.length;
    },
  },
  methods: {
    getAprovacao() {
      this.loading = true;
      AprovacaoService.get(this.id)
        .then((response) => {
          this.aprovacao = response.data;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    onUpdate() {
      this.getAprovacao();
    },
  },
  created() {
    this.id = this.aprovacaoIdProp || this.$route.params.id;
    this.getAprovacao();
  },
  components: {
    AprovacaoDetalhesTabs,
    AprovacaoDetalhesProdutos,
    AprovacaoDetalhesAprovadores,
    AprovacaoDetalhesDadosBasicos,
    AprovacaoDetalhesMensagensPersonalizadas,
  },
};
</script>
